import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_1540_29978)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.6654 1.67936C11.4919 1.67936 11.3255 1.74828 11.2028 1.87094L5.77543 7.29836L5.46708 8.53175L6.70047 8.2234L12.1279 2.79599C12.2506 2.67332 12.3195 2.50694 12.3195 2.33347C12.3195 2.15999 12.2506 1.99361 12.1279 1.87094C12.0052 1.74828 11.8388 1.67936 11.6654 1.67936ZM10.3779 1.04599C10.7193 0.704526 11.1825 0.512695 11.6654 0.512695C12.1483 0.512695 12.6114 0.704526 12.9528 1.04599C13.2943 1.38745 13.4861 1.85057 13.4861 2.33347C13.4861 2.81636 13.2943 3.27948 12.9528 3.62094L7.41118 9.16261C7.33642 9.23737 7.24275 9.29041 7.14018 9.31605L4.80684 9.89938C4.60806 9.94908 4.39777 9.89083 4.25289 9.74594C4.108 9.60106 4.04975 9.39077 4.09945 9.19199L4.68278 6.85865C4.70842 6.75608 4.76146 6.66241 4.83622 6.58765L10.3779 1.04599ZM1.09459 2.2627C1.42278 1.93451 1.8679 1.75013 2.33203 1.75013H6.41536C6.73753 1.75013 6.9987 2.0113 6.9987 2.33347C6.9987 2.65563 6.73753 2.9168 6.41536 2.9168H2.33203C2.17732 2.9168 2.02895 2.97826 1.91955 3.08765C1.81016 3.19705 1.7487 3.34542 1.7487 3.50013V11.6668C1.7487 11.8215 1.81016 11.9699 1.91955 12.0793C2.02895 12.1887 2.17732 12.2501 2.33203 12.2501H10.4987C10.6534 12.2501 10.8018 12.1887 10.9112 12.0793C11.0206 11.9699 11.082 11.8215 11.082 11.6668V7.58347C11.082 7.2613 11.3432 7.00013 11.6654 7.00013C11.9875 7.00013 12.2487 7.2613 12.2487 7.58347V11.6668C12.2487 12.1309 12.0643 12.576 11.7361 12.9042C11.4079 13.2324 10.9628 13.4168 10.4987 13.4168H2.33203C1.8679 13.4168 1.42278 13.2324 1.09459 12.9042C0.766406 12.576 0.582031 12.1309 0.582031 11.6668V3.50013C0.582031 3.036 0.766406 2.59088 1.09459 2.2627Z",
    fill: "#2B3951"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_1540_29978" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "14",
      height: "14",
      fill: "white"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render };